"use client";

import Link from "next/link";
import { ArrowUpLeft } from "lucide-react";

import { useApi } from "@/src/api/useApi";
import ProductListV1 from "@/src/components/product/ProductListV1";
import { ProductListType } from "@/src/types/product";

interface Props {
  articleId: number;
  title?: string;
}

const RelatedProducts: React.FC<Props> = ({
  articleId,
  title = "محصولات مرتبط",
}) => {
  const { data, isLoading } = useApi<ProductListType>(
    `/product-similar?ArticleId=${articleId}`,
    { revalidateOnFocus: false },
  );

  const rows = data?.data?.rows ?? [];
  if (isLoading || rows.length === 0) return null;

  return (
    <section className="mt-8">
      <div className="mb-3 flex items-center justify-between gap-3">
        <h2 className="text-base sm:text-lg font-bold text-gray-800 flex items-center gap-2">
          <span className="block w-1 h-5 rounded-full bg-blue-500"></span>
          {title}
        </h2>
        <Link
          href="/search"
          className="inline-flex items-center gap-1 text-xs font-semibold text-blue-600 hover:text-blue-700"
        >
          مشاهده همه
          <ArrowUpLeft className="w-3.5 h-3.5" />
        </Link>
      </div>
      <div className="rounded-2xl bg-white/50 border border-gray-100 p-1.5 sm:p-2">
        <ProductListV1 data={rows} />
      </div>
    </section>
  );
};

export default RelatedProducts;
